<template>
  <div class="join-form">
    <div class="join-form--left">
      <div class="join-form--left--benefits">
        <div class="join-form--left--top">
          <h2>Member Portal</h2>
          <p>You now have access to the award-winning membership portal which has been carefully curated to meet our
            members needs. The portal makes it easy to manage your membership, connect with fellow members, stay up to
            date on the industry, and more!</p>
        </div>
        <div class="join-form--left--image">
          <img src="/modules/amacustom/ama/ama_dashboard/images/d-m-dashboard.png" class="last-image" />
        </div>
      </div>
    </div>
    <div class="join-form--right">
      <div class="join-form--step step-eight">
        <div class="completed-check">
          <!--<i class="far fa-check"></i>-->
          <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
        <h2 class="text-center">Welcome to the Australian Medical Association</h2>
        <div class="step-intro">You have joined tens of thousands of Doctors in Australia's largest medical association,
          advocating together for your rights and better health outcomes for our communities.</div>
        <a class="button button-blue button-block button-nm" href="/sign-in">Sign in to AMA Member Portal</a>
        <div v-if="form.stage != 'student'">
          <hr>
          <table>
            <tbody>
              <tr>
                <td>Payment information</td>
                <td class="text-end">
                  <a @click.prevent="print" href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path
                        d="M19 8.5H5C3.34 8.5 2 9.84 2 11.5V17.5H6V21.5H18V17.5H22V11.5C22 9.84 20.66 8.5 19 8.5ZM16 19.5H8V14.5H16V19.5ZM19 12.5C18.45 12.5 18 12.05 18 11.5C18 10.95 18.45 10.5 19 10.5C19.55 10.5 20 10.95 20 11.5C20 12.05 19.55 12.5 19 12.5ZM18 3.5H6V7.5H18V3.5Z"
                        fill="black" />
                    </svg>
                  </a>
                  <a @click.prevent="printPdf" href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path
                        d="M20 2.5H8C6.9 2.5 6 3.4 6 4.5V16.5C6 17.6 6.9 18.5 8 18.5H20C21.1 18.5 22 17.6 22 16.5V4.5C22 3.4 21.1 2.5 20 2.5ZM11.5 10C11.5 10.83 10.83 11.5 10 11.5H9V13.5H7.5V7.5H10C10.83 7.5 11.5 8.17 11.5 9V10ZM16.5 12C16.5 12.83 15.83 13.5 15 13.5H12.5V7.5H15C15.83 7.5 16.5 8.17 16.5 9V12ZM20.5 9H19V10H20.5V11.5H19V13.5H17.5V7.5H20.5V9ZM9 10H10V9H9V10ZM4 6.5H2V20.5C2 21.6 2.9 22.5 4 22.5H18V20.5H4V6.5ZM14 12H15V9H14V12Z"
                        fill="black" />
                    </svg>
                  </a>
                </td>
              </tr>
              <tr>
                <td>Membership number</td>
                <td>
                  <strong>{{ form.imis }}</strong>
                </td>
              </tr>
              <tr>
                <td>Payment date</td>
                <td>
                  <strong>{{ today }}</strong>
                </td>
              </tr>
              <tr>
                <td>Payment type</td>
                <td>
                  <strong v-if="form.paymentType == 'cc'" class="text-uppercase">{{ form.card.type }}</strong>
                  <strong v-else class="text-uppercase">Direct Debit</strong>
                </td>
              </tr>
              <tr>
                <td v-if="form.paymentType == 'cc'">Card holder name</td>
                <td v-else>Account name</td>
                <td>
                  <strong v-if="form.paymentType == 'cc'" class="text-uppercase">{{ form.card.name }}</strong>
                  <strong v-else class="text-uppercase">{{ form.etf.name }}</strong>
                </td>
              </tr>
              <tr>
                <td>Billing cycle</td>
                <td>
                  <strong class="text-uppercase">{{ labels[form.payment] || '' }}</strong>
                </td>
              </tr>
              <tr>
                <td>Total paid amount</td>
                <td>
                  <!---<strong v-if="form.cpd_sub">${{ form.price|cpdTotal(form.cpd_sub) }}</strong>-->
                  <strong>{{ form.price|currency(discount) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  name: 'step-seven',
  props: ['step', 'form', 'discount'],
  components: {
  },
  data() {
    return {
      labels: {
        M: 'Monthly',
        F: 'Fortnightly',
        Q: 'Quarterly',
        A: 'Annual',
      },
      today: dayjs().format('DD/MM/YYYY'),
    }
  },
  filters: {
    cpdTotal(value, check) {
        if (check) {
          var total = (value + 220).toFixed(2)
          return total
        }
      },
    currency(value, discount) {
      var vdiscount = (1 - parseFloat(discount).toFixed(2));
      return `$${(parseFloat(value) * vdiscount).toFixed(2)}`;
    },
  },
  computed: {
  },
  methods: {
    printPdf() {
      var element = document.getElementById('app');
      window.html2pdf(element);
    },
    print() {
      window.print();
    },
  },
  mounted() {
  }
}
</script>